import PropTypes from "prop-types"
import React, { useState, useEffect } from "react"
import { Row, Col, Card, CardBody, Container, Label } from "reactstrap"
import { Formik, Form, Field, ErrorMessage } from "lib/formik"

//redux
import { useSelector, useDispatch } from "react-redux"
import { Link } from "react-router-dom"
import withRouter from "components/Common/withRouter"

// Formik Validation
import * as Yup from "utils/yup"
import { useFormik } from "lib/formik"

import AuthBrandingLogo from "components/Authentication/AuthBrandingLogo"
import { ROUTES } from "constants/routes"
import useAuthPageBranding from "hooks/useAuthPageBranding"
import {
  resetPasswordSchema,
  verifyOTPSchema,
  verifyPasswordSchema,
} from "components/Common/validation"
import { changePassword, resendForgotPasswordOtp, verifyOtp } from "store/actions/authAction"
import { showAlert } from "store/reducers/alertReducer"
import { useTranslation } from "react-i18next"
import TextError from "components/Shared/TextError"
import useOtpResendCooldown, {
  otpRetrySeconds,
  resendButtonLabel,
} from "hooks/useOtpResendCooldown"

const VerifyPassword = props => {
  const { t } = useTranslation()
  const { brandTitle, authPageClassName } = useAuthPageBranding(
    t("Verify password")
  )

  const [tempOtp, TempOtp] = useState(null)
  const [showPassword, setShowPassword] = useState(false)
  const [showConfirmPassword, setShowConfirmPassword] = useState(false)

  const dispatch = useDispatch()
  const rawResendAt = sessionStorage.getItem("otpResendAvailableAt")
  const storedResendAt = rawResendAt ? Number(rawResendAt) : NaN
  const initialResendWait = Number.isFinite(storedResendAt)
    ? Math.max(0, Math.ceil((storedResendAt - Date.now()) / 1000))
    : 60
  const [resending, setResending] = useState(false)
  const [resendIn, setResendIn] = useOtpResendCooldown(initialResendWait)

  const {
    loading,
    verifyPasswordStep,
    verifyPasswordError,
    changePasswordError,
    varifyPasswordSuccesMsg,
    changePasswordSuccessMsg,
    error,
    message,
    actionType,
  } = useSelector(state => state.Login)
  // console.log(verifyPasswordStep)
  const handleOtpVerify = values => {
    const forgotEmail = sessionStorage.getItem("forgotEmail")
    const payload = {
      email: forgotEmail,
      otp: values.otp,
    }
    TempOtp(values.otp)
    dispatch(verifyOtp({ ...payload, history: props.router.navigate })).then(
      action => {
        const { statusCode, status, msg } = action?.payload
        if (statusCode === 200 && status) {
          dispatch(showAlert({ text: msg, type: "success" }))
        } else {
          dispatch(showAlert({ text: msg, type: "error" }))
          const wait = otpRetrySeconds(action?.payload)
          if (wait) {
            setResendIn(wait)
          }
        }
      }
    )
  }

  const handleResend = () => {
    const forgotEmail = sessionStorage.getItem("forgotEmail")
    if (!forgotEmail || resendIn > 0 || resending) return
    setResending(true)
    dispatch(resendForgotPasswordOtp({ email: forgotEmail }))
      .then(action => {
        const payload = action?.payload || {}
        const isSuccess = payload.statusCode === 200 && payload.status
        dispatch(
          showAlert({
            text: payload.msg || t("Could not send verification code. Please try again."),
            type: isSuccess ? "success" : "error",
          })
        )
        const wait = otpRetrySeconds(payload, isSuccess ? 60 : 0)
        if (wait) {
          setResendIn(wait)
          sessionStorage.setItem(
            "otpResendAvailableAt",
            String(Date.now() + wait * 1000)
          )
        }
      })
      .finally(() => setResending(false))
  }

  const handlePasswordChange = values => {
    const forgotEmail = sessionStorage.getItem("forgotEmail")
    const { newPassword, confirmPassword } = values
    const payload = {
      email: forgotEmail,
      otp: tempOtp,
      newPassword,
      confirmPassword,
    }
    dispatch(changePassword({ ...payload, history: props.router.navigate }))
      .then(action => {
        const { statusCode, status, msg } = action?.payload
        if (statusCode === 200 && status) {
          dispatch(showAlert({ text: msg, type: "success" }))
        } else {
          dispatch(showAlert({ text: msg, type: "error" }))
        }
      })
      .catch(error => {})
  }

  return (
    <React.Fragment>
      <div
        className={`account-pages my-5 pt-sm-5 ${authPageClassName}`}
      >
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div
                  className="login-platform-hero"
                >
                  <Row>
                    <Col xs={12}>
                      <div
                        className="p-4"
                      >
                        <h5>{brandTitle}</h5>
                        <p>{t("Verify your OTP or set a new password.")}</p>
                      </div>
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <AuthBrandingLogo />
                  <div className="p-2">
                    {verifyPasswordStep === "NEW_PASSWORD" ? (
                      <Formik
                        enableReinitialize={true}
                        initialValues={{ newPassword: "", confirmPassword: "" }}
                        validationSchema={verifyPasswordSchema}
                        onSubmit={handlePasswordChange}
                      >
                        {({ values, errors, touched, isSubmitting }) => (
                          <Form className="form-horizontal">
                            <div className="mb-3">
                              <Label className="form-label">
                                {t("New Password")}
                              </Label>
                              <div className="position-relative">
                                <Field
                                  name="newPassword"
                                  className={`form-control ${
                                    touched.newPassword &&
                                    errors.newPassword &&
                                    "is-invalid"
                                  }`}
                                  placeholder={t("New Password")}
                                  type={showPassword ? "text" : "password"}
                                />
                                <i
                                  onClick={() => setShowPassword(!showPassword)}
                                  className={`bx bx-${
                                    showPassword ? "show-alt" : "hide"
                                  } common_eye`}
                                ></i>
                              </div>
                              <TextError name="newPassword" />
                            </div>
                            <div className="mb-3">
                              <Label className="form-label">
                                {t("Confirm Password")}
                              </Label>
                              <div className="position-relative">
                                <Field
                                  name="confirmPassword"
                                  className={`form-control ${
                                    touched.confirmPassword &&
                                    errors.confirmPassword &&
                                    "is-invalid"
                                  }`}
                                  placeholder={t("Confirm Password")}
                                  type={
                                    showConfirmPassword ? "text" : "password"
                                  }
                                />
                                <i
                                  onClick={() =>
                                    setShowConfirmPassword(!showConfirmPassword)
                                  }
                                  className={`bx bx-${
                                    showConfirmPassword ? "show-alt" : "hide"
                                  } common_eye`}
                                ></i>
                              </div>
                              <TextError name="confirmPassword" />
                            </div>
                            <Row className="mb-3">
                              <Col className="text-end">
                                <button
                                  className="btn btn-primary w-md "
                                  type="submit"
                                  disabled={isSubmitting}
                                >
                                  {t("Save")}
                                </button>
                              </Col>
                            </Row>
                          </Form>
                        )}
                      </Formik>
                    ) : (
                      <Formik
                        enableReinitialize={true}
                        initialValues={{ otp: null }}
                        validationSchema={verifyOTPSchema}
                        onSubmit={handleOtpVerify}
                      >
                        {({ values, errors, touched, isSubmitting }) => (
                          <Form className="form-horizontal">
                            <div className="mb-3">
                              <Label className="form-label">
                                {t("Verify OTP")}
                              </Label>
                              <Field
                                name="otp"
                                className={`form-control ${
                                  touched.otp && errors.otp && "is-invalid"
                                }`}
                                placeholder={t("Verify OTP")}
                                type="text"
                              />
                              <TextError name="otp" />
                            </div>
                            <Row className="mb-3">
                              <Col className="text-end">
                                <button
                                  className="btn btn-primary w-md "
                                  type="submit"
                                  disabled={loading}
                                >
                                  {t("Verify")}
                                </button>
                              </Col>
                            </Row>
                            <div className="text-center">
                              <span className="text-muted">
                                {t("Didn't receive the code?")}
                              </span>{" "}
                              <button
                                type="button"
                                className="btn btn-link p-0 align-baseline"
                                onClick={handleResend}
                                disabled={resending || loading || resendIn > 0}
                              >
                                {resendButtonLabel(t, resendIn, t("Resend OTP"))}
                              </button>
                            </div>
                          </Form>
                        )}
                      </Formik>
                    )}
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center login-platform-footer">
                <p>
                  {t("Go back to")}{" "}
                  <Link
                    to={ROUTES.LOGIN}
                    className="font-weight-medium text-primary"
                  >
                    {t("Login")}
                  </Link>{" "}
                </p>
                {/* <p>
                  © {new Date().getFullYear()} Skote. Crafted with{" "}
                  <i className="mdi mdi-heart text-danger" /> by Themesbrand
                </p> */}
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

VerifyPassword.propTypes = {
  history: PropTypes.object,
}

export default withRouter(VerifyPassword)
